require('./bootstrap');
require('overlayscrollbars');
require('../../vendor/almasaeed2010/adminlte/dist/js/adminlte');
window.Swal = require('sweetalert2');